import { APIService } from './api';
import { isDemo } from '../preview';
import { FilterData, FilterQuery, SalesLotsResponse } from '../pages/Lots/types';
import { filterEmptyStringFromObject } from '../utils';

export async function loadFilters(): Promise<FilterData> {
  if (isDemo) return (await import('../preview-data')).demoFilters;
  return (await APIService.get<FilterData>('/sales/filter', { timeout: 30000 })).data;
}

export async function loadLots(filter: Partial<FilterQuery>): Promise<SalesLotsResponse> {
  if (isDemo) return (await import('../preview-data')).filterDemoLots(filter);
  return (await APIService.post<SalesLotsResponse>(
    '/sales/filter', filterEmptyStringFromObject(filter), { timeout: 30000 },
  )).data;
}
